<template>
	<div class="px-4 text-center sm:px-8">
		<h2 class="text-2xl leading-tight sm:text-3xl md:text-4xl xl:text-5xl">Browse Our Selection Of HD Satellite Antenna Bundles</h2>
		<p class="text-lg mt-2 lg:text-2xl xl:text-3xl">All antennas come bundled with DISH Outdoors HD Wally receiver!</p>
		<Flickity ref="flickity" class="flickity-on -mx-4 mt-2 sm:-mx-8 lg:flex lg:mt-4 lg:flickity-off" :options="flickityOptions">
			<div v-for="(antenna, index) in antennas" :key="index" class="w-5/6 py-4 px-2 max-w-xs min-h-full sm:w-5/12 lg:pb-0 lg:flex-grow lg:px-0">
				<div class="shadow py-2 px-2 h-full lg:shadow-none">
					<img class="mx-auto lg:w-3/4" :src="antenna.img" alt="whatever" @load="resizeAntennas">
					<div class="px-2 pb-2 mt-4 flex flex-col leading-tight lg:pb-0" :class="index == 0 ? '' : 'lg:border-l-2 border-gray-700'">
						<h4 class="font-bold text-xl xl:text-2xl">{{ antenna.name }}</h4>
						<div class="text-lg mt-2 space-y-2 xl:text-xl">
							<p>Automatic signal finder</p>
							<p>{{ antenna.tagline }}</p>
							<p>{{ antenna.tvs }} TV Option</p>
						</div>
						<a :href="antenna.link" class="mt-4 text-white bg-dish-red py-2 px-4 rounded font-semibold mx-auto xl:text-xl">Shop Now</a>
					</div>
				</div>
			</div>
		</Flickity>
	</div>
</template>

<script lang="ts">
	import { Options } from 'flickity'
	import { defineComponent, Ref, ref } from 'vue'

	import Playmaker from '@/assets/image/Playmaker.png'
	import TailgaterPro from '@/assets/image/Tailgater-Pro.png'
	import Tailgater from '@/assets/image/Tailgater.png'
	import X2 from '@/assets/image/x2.png'
	import Flickity from '@/components/Flickity.vue'

	interface AntennaData {
		img: string,
		name: string,
		tagline: string,
		tvs: number,
		link: string,
	}

	export default defineComponent({
		components: {
			Flickity,
		},

		setup() {
			const flickity: Ref<typeof Flickity | null> = ref(null)

			const antennas: Array<AntennaData> = [
				{ img: Playmaker, name: 'DISH Playmaker®', tagline: 'Compact and lightweight', tvs: 1, link: 'https://www.dishformyrv.com/new-dish-playmaker-bundle-with-wally/' },
				{ img: TailgaterPro, name: 'DISH Tailgater®', tagline: 'Portable and mountable', tvs: 1, link: 'https://www.dishformyrv.com/dish-tailgater-satellite-antenna-bundle-with-wally/' },
				{ img: Tailgater, name: 'DISH Tailgater® Pro', tagline: '100% Nationwide coverage', tvs: 2, link: 'https://www.dishformyrv.com/dish-tailgater-pro-satellite-antenna-bundle-with-wally/' },
				{ img: X2, name: 'Pathway® X2', tagline: 'Best option for East Coast', tvs: 2, link: 'https://www.dishformyrv.com/winegard-pathway-x2-bundle-with-wally/' },
			]

			const flickityOptions: Options = {
				groupCells: true,
				pageDots: false,
				watchCSS: true,
			}

			function resizeAntennas(): void {
				flickity.value!.resize()
			}

			return {
				flickity,
				resizeAntennas,
				antennas,
				flickityOptions,
			}
		},
	})
</script>
